import React from 'react';
import loadable from '@loadable/component';

const EmojiPicker = loadable(() => import('./EmojiPicker'));

const WpEmojiPicker = () => {
  return <EmojiPicker />;
};

export default WpEmojiPicker;
